import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

const requestPaymentInfoForAthlete = (athleteId: string): Promise<AxiosResponse<null>> => {
  return client.post(`athletes/${athleteId}/request-payment-info/`);
};

export default function useRequestPaymentInfoForAthlete(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  return useMutation(requestPaymentInfoForAthlete);
}
